<template>
    <nav>
        <modal v-if="showModal" :brand="brand" :campaign="campaign" :zone="zone"></modal>
        <div id="searchBar" class="flexContainer ai-c jc-sb m-jc-sa">
            <div id="logoClient"><img :src="brandLogo" alt="" class="imgBrand" width="140" /></div>
            <div id="searchInputNotPlano" class="mobileNot" v-if="$route.name !== 'Planos'">
                <div class="inputSearch iBlock">
                    <input
                        id="searchInput"
                        type="search"
                        :placeholder="$t('common.search')"
                        v-model.trim="search"
                        @keyup.enter="submit(selected !== null ? { search, type: selected } : { search });"
                    />
                    <!-- <img src="../../assets/cross.png" alt="" width="10" height="10" class="cross" @click="reset" v-if="search !== ''" /> -->
                </div>
                <div class="selectSearch iBlock">
                    <select name="" id="" class="uppercase selectBrand" v-model="selected">
                        <option :value="''" selected>{{ $t("common.searchAll") }}</option>
                        <option v-for="(option, key) in optionsTypeFilter" :value="option.id" :key="key">{{
                            getTranslate(option.terms.name)
                        }}</option>
                        <option :value="'shade'" selected>shades</option>
                    </select>
                </div>
                <div class="btnSearch iBlock">
                    <button @click="getLinkParams({ search, type: selected, offset: 1 });" style="background: none; border: none;">
                        <i class="fas fa-search primary-text fa-lg"></i>
                    </button>
                </div>
            </div>

            <div id="searchInputWrapper" class="flexContainer ai-c jc-sb mobileNot" v-if="$route.name === 'Planos'">
                <input
                    id="searchInput"
                    type="search"
                    :placeholder="$t('plano.search_planogram')"
                    v-model="search"
                    @keyup.enter="submit({ search });"
                />
                <div class="ai-c">
                    <img src="../../assets/cross.png" alt="" width="10" height="10" class="cross" @click="reset" v-if="search !== ''" />
                </div>
                <div class="ai-c">
                    <router-link :to="{ name: 'Planos', query: getLinkParams({ search }) }">
                        <img id="glass" src="../../assets/loupe.png" />
                    </router-link>
                </div>
            </div>
            <div class="select flexContainer" id="zoneCampaign">
                <ul class="list-inline mobileNot campaignName">
                    <li class="list-inline-item" v-if="Object.keys(rem3rchUser.user.brands).length > 1" @click="modal('brand');">
                        <div class="triangle pointer"></div>
                        <span class="campaign uppercase pointer bold">{{ currentBrand.name }}</span>
                    </li>
                    <li class="list-inline-item" v-else>
                        <div class="triangle"></div>
                        <span class="campaign uppercase bold">{{ currentBrand.name }}</span>
                    </li>
                    <li class="list-inline-item" v-if="zoneL.length > 1" @click="modal('zone');">
                        <div class="triangle pointer"></div>
                        <span v-if="currentZone.name != null">
                            <span class="campaign uppercase pointer bold" v-if="currentZone.name.length < 13">{{ currentZone.name }}</span>
                            <span class="campaign uppercase pointer bold" v-else-if="currentZone" v-b-tooltip.hover.bottom="currentZone.name">{{
                                currentZone.name | trim
                            }}</span>
                        </span>
                    </li>
                    <li class="list-inline-item" v-else>
                        <div class="triangle"></div>
                        <span v-if="currentZone.name != null">
                            <span class="campaign uppercase bold" v-if="currentZone.name.length < 13">{{ currentZone.name }}</span>
                            <span class="campaign uppercase bold" v-else-if="currentZone" v-b-tooltip.hover.bottom="currentZone.name">{{
                                currentZone.name | trim
                            }}</span>
                        </span>
                    </li>
                    <li class="list-inline-item" v-if="currentCampaign.name != null && campaignL.length > 1" @click="modal('campaign');">
                        <div class="triangle pointer"></div>
                        <span class="campaign uppercase pointer bold"> {{ currentCampaign.name }}</span>
                    </li>
                    <li class="list-inline-item" v-if="currentCampaign.name == null && campaignL.length > 1" @click="modal('campaign');">
                        <span class="campaign uppercase pointer bold"> {{ $t("dashboardModule.allCampaign") }}</span>
                    </li>
                </ul>
            </div>
            <div class="mobileOnly tabletNot mobileSearchWrapper flexContainer m-as-s m-fd-r m-ai-c m-jc-fs">
                <div class="select abs tabletNot" id="zoneCampaignMobile" v-if="mobileSearchDisplay === false">
                    <div class="bloc campaignName" v-if="currentCampaign.shortName != null">
                        <span class="uppercase">{{ currentCampaign.shortName }}</span>
                    </div>
                    <div class="campaignName bold" v-if="currentCampaign.shortName == null">
                        <span class="uppercase">{{ $t("dashboardModule.allCampaignShort") }}</span>
                    </div>
                    <div class="bloc zoneName" v-if="currentCampaign.shortName && currentCampaign.shortName.length > 1">
                        <span class="triangle"></span> <span class="zoneNameText uppercase">{{ currentCampaign.shortName }}</span>
                    </div>
                </div>
                <div class="mobileSearchButton" v-on:click="displayMobileSearch" v-if="mobileSearchDisplay === false">
                    <i class="fas fa-search fa-1x" aria-hidden="true"></i>
                </div>
                <div class="mobileSearchInputWrapper m-as-s m-f-10 m-ai-c flexContainer" v-if="mobileSearchDisplay">
                    <input type="text" placeholder="Search terms" class="mobileSearchInput m-f-10" v-model="search" />
                </div>
                <div class="ai-c">
                    <router-link :to="{ name: 'Catalog', query: getLinkParams({ search }) }" v-if="mobileSearchDisplay">
                        <button class="btn">{{ $t("common.ok") }}</button>
                    </router-link>
                </div>
                <div class="ai-c"><img src="../../assets/croix.png" alt="" class="crossMob" @click="reset" v-if="search !== ''" /></div>
            </div>
        </div>
    </nav>
</template>

<script>
import Globals from "../globals.js";
import { mapGetters, mapState, mapActions } from "vuex";
import Modal from "../modal/modal.vue";
import { bus } from "../../main";
import cacheService from "@/services/cache";

export default {
    components: {
        modal: Modal
    },
    data: () => ({
        selected: "",
        optionsTypeFilter: [],
        mobileSearchDisplay: false,
        routeParams: {},
        search: "",
        rem3rchUser: {},
        showModal: false,
        brand: false,
        zone: false,
        campaign: false,
        option: "",
        zoneL: {},
        standL: {},
        campaignL: [],
        selectedZone: cacheService.getCurrentZoneName(),
        logoBrand: cacheService.getCurrentBrandImg
    }),
    watch: {
        $route(to, from) {
            this.selected = to.query.type ? to.query.type : "";
        }
    },
    methods: {
        ...mapActions("currentUser/", ["populateInfo"]),
        ...mapActions("brand/", ["populate"]),
        submit(search) {
            if (this.$route.name !== "Planos") {
                if (search.type === "shade") {
                    this.$router.push({ name: "Shades", query: this.getLinkParams(search) });
                }
                if (search.type === "") {
                    this.$router.push({ name: "SearchAllComponents", query: this.getLinkParams(search) });
                }
                if (search.type !== "" && search.type !== "shade") {
                    this.$router.push({ name: "Catalog", query: this.getLinkParams(search) });
                    this.$store.dispatch("catalog/search/setQuery", { search: search }).then(() => {});
                }
            } else {
                this.$router.push({ name: "Planos", query: this.getLinkParams(search === null ? undefined : search) });
                this.$store.dispatch("planos/search/setQuery", { search: search }).then(() => {});
            }
        },
        displayMobileSearch() {
            this.mobileSearchDisplay = true;
        },
        closeMobileSearch() {
            this.mobileSearchDisplay = false;
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.$route.query) {
                temp[key] = this.$route.query[key];
            }
            for (let key in x) {
                temp[key] = x[key];
            }
            if (this.$route.name !== "Planos") {
                if (!temp.type) {
                    this.trackEventMatomo("trackEvent", "Search", "SELECT", "SearchAllComponents");
                    this.$router.push({ name: "SearchAllComponents", query: temp });
                }
                if (temp.type === "shade") {
                    this.trackEventMatomo("trackEvent", "Search", "SELECT", "Shades");
                    this.$router.push({ name: "Shades", query: temp });
                }
                if (temp.type !== "shade" && temp.type !== "") {
                    let typeName = this.optionsTypeFilter.filter(v => {
                        return parseInt(v.id) === parseInt(temp.type);
                    });
                    if (typeName.length > 0) {
                        this.trackEventMatomo("trackEvent", "Search", "SELECT", typeName[0].name);
                    }
                    this.$router.push({ name: "Catalog", query: temp });
                }
            }
            return temp;
        },
        getRouteParams() {
            return this.routeParams;
        },
        setRouteParams(params) {
            let temp = {};
            for (let key in params) {
                if (key !== "url" && key !== "method") {
                    temp[key] = params[key];
                }
            }
            this.routeParams = temp;
        },
        updateQuery(to) {
            this.setRouteParams(to.query);
            this.$store.dispatch("catalog/search/getResults", { routeParams: this.routeParams }).then(() => {
                this.updateVueResults(this.getResults());
            });
        },
        updateVueResults(datas) {
            this.searchResults = datas;
        },
        reset() {
            this.search = "";
            this.selected = "";
            this.mobileSearchDisplay = false;
            this.$router.push({ name: "Catalog" });
            bus.$emit("resetSearch", "");
            if (this.route.name === "Planos") {
                this.$router.push({ name: "Planos" });
            }
        },
        clear() {
            this.search = "";
            this.mobileSearchDisplay = false;
        },
        modal(a) {
            this.option = a;
            this.trackEventMatomo("trackEvent", "Modal options", "MODAL", this.option);
            if (this.option === "brand") {
                this.showModal = true;
                this.brand = true;
                this.zone = false;
                this.campaign = false;
            } else if (this.option === "zone") {
                this.showModal = true;
                this.zone = true;
                this.brand = false;
                this.campaign = false;
            } else if (this.option === "campaign") {
                this.showModal = true;
                this.campaign = true;
                this.brand = false;
                this.zone = false;
            } else {
                this.showModal = false;
            }
        },
        modalClose(close) {
            this.showModal = close;
        },
        zoneSelected(zone) {
            this.selectedZone = zone;
        },
        optionReset(option) {
            this.option = option;
        },
        async loadCurrentInfos() {
            await this.populateInfo();
        }
    },
    computed: {
        ...mapState("currentUser/", ["currentBrand", "currentZone", "currentCampaign"]),
        ...mapGetters("catalog/filters/", {
            getFilters: "getFilters"
        }),
        ...mapGetters("catalog/search/", {
            getResults: "getResults",
            getQuery: "getQuery"
        }),
        brandLogo() {
            return Globals.getBaseUrl() + this.currentBrand.imgPath + this.currentBrand.logo;
        }
    },
    created() {
        this.$store.dispatch("catalog/filters/populate", { routeParams: {} }).then(() => {
            this.optionsTypeFilter = this.getFilters("types");
        });
        this.loadCurrentInfos();
        bus.$on("resetFilters", event => {
            this.clear();
        });
        bus.$on("updateSearch", event => {
            this.search = event;
        });

        bus.$on("closeModal", event => {
            this.modalClose(event);
        });
        bus.$on("zoneSaved", event => {
            this.zoneSelected(event);
        });
        bus.$on("resetOption", event => {
            this.optionReset(event);
        });

        let params = this.getRouteParams();
        this.$store.dispatch("catalog/search/getResults", params).then(() => {
            this.updateVueResults(this.getResults(20));
        });
        this.rem3rchUser = cacheService.getRem3rchUser();
        this.option = "null";
        bus.$on("defaultZone", modalZone => {});
        let currentBID = parseInt(cacheService.getCurrentBrandId(), 10);
        for (let i = 0; i < Object.keys(this.rem3rchUser.user.brands).length; i++) {
            if (Object.values(this.rem3rchUser.user.brands)[i].id === currentBID) {
                this.zoneL = Object.values(this.rem3rchUser.user.brands)[i].zones;
                this.standL = Object.values(this.rem3rchUser.user.brands)[i].stands;
                this.campaignL = Object.values(this.rem3rchUser.user.brands)[i].campaigns;
            }
        }
    },
    filters: {
        trim: value => {
            if (value.length < 13) return value;
            return value.substring(0, 12) + "...";
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

#searchInputNotPlano {
    display: flex;

    .selectSearch {
        select {
            border: none;
            background: none;
            border-bottom: 2px solid #333333;
            padding: 8px;
            margin-left: 10px;
            min-width: 150px;
            color: #727272;
        }
    }
    .btnSearch {
        margin-left: 10px;
        top: 5px;
        position: relative;
    }
}
#logoClient {
    position: relative;
    .imgBrand {
        max-height: 50px;
        width: auto;
        object-fit: contain;
    }
}
.triangle {
    display: inline-block;
    margin: 0 5px;
    vertical-align: middle;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 4.5px 0 4.5px 6px;
    border-color: transparent transparent transparent #343434;
    margin-bottom: 4px;
}
.campaign {
    padding-right: 15px;
}
.campaignName {
    padding: 7px 4px;
    font-size: 14px;
    font-family: Roboto;
    @extend %second-text;
    margin: 0;
    span {
        @media only screen and (max-width: 1158px) {
            font-size: 11px;
            padding: 7px 2px;
        }
    }
}
#searchBar {
    background-color: #fff;
    height: 60px;
    padding: 0 20px;
    position: relative;
    z-index: 0;
    p {
        font-size: 1.4em;
        @extend %primary-text;
    }
}
#searchInput {
    padding: 0.5em;
    font-size: 14px;
    border: none;
    border-bottom: 2px solid #333333;
    width: 320px;
    background-color: transparent;
    @extend %primary-border-color;
    @extend %second-text;
    &::placeholder {
        @extend %primary-text;
        opacity: 1;
    }

    &:-ms-input-placeholder {
        @extend %primary-text;
    }

    &::-ms-input-placeholder {
        @extend %primary-text;
    }
    @media only screen and (max-width: 992px) {
        width: 285px;
    }
}
#searchInput:focus {
    outline: none;
}
#glass {
    z-index: 1;
    height: 15px;
    padding: 1%;
    margin-left: -20px;
}
.selectedBrand {
    color: #95989a;
    font-size: 1.4rem;
    text-transform: uppercase;
    border: none;
}

@media only screen and (max-width: 767px) {
    #zoneCampaignMobile {
        margin-left: 64%;
        & > div {
            display: inline-block;
            font-size: 12px;
            color: #727272;
        }
        .campaignName {
            span {
                padding-right: 0;
            }
        }
        .bloc {
            display: inline-block;
            .zoneNameText {
                font-size: 12px;
                color: #727272;
            }
        }
    }
    #zoneCampaign {
        border: none;
    }
    #logoClient {
        text-align: center;
        .imgBrand {
            max-width: 200px;
        }
    }
    #searchInput {
        width: auto;
    }
    .mobileSearchWrapper {
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        padding: 0 20px;
    }
    .mobileSearchInputWrapper {
        height: 100%;
        background-color: white;
        .mobileSearchInput {
            border: 0;
            margin: 0 20px;
            font-size: 1.6rem;
            border-bottom: 1px solid black;
            height: 30px;
        }
    }
    .mobileSearchButton {
        width: 20px;
        .fa-search {
            color: black;
            .dark & {
                color: white;
            }
        }
    }
    .mobileSearchClose {
        width: 20px;
        height: 100%;
        background: red url(../../assets/loupe.png) no-repeat center center;
    }
}
.crossMob {
    z-index: 2;
    margin-left: 10px;
}

.cross {
    z-index: 2;
    margin-left: -35px;
}
</style>



// WEBPACK FOOTER //
// SearchHeader.vue?4bf86f5a